/// <reference path="../types.d.ts" />

import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from '../core/net';
import {
  commonActions,
  caseUtils,
  appServiceLines,
  authenticationChannel
} from '@codametrix/ui-common';

const { CaseJSON } = commonActions;

type CaseAndProcess = {
  caseDetail: CMxAPI.Case;
  activeProcess: CMxAPI.CaseRun;
};

const setActiveProcess = createAction<CMxAPI.CaseRun>(
  CaseJSON.SET_ACTIVE_PROCESS
);

const onLoad = createAsyncThunk(CaseJSON.LOAD, async (
  arg,
  {
    dispatch,
    getState,
    rejectWithValue
  }
) => {
  await authenticationChannel.ready;

  const url = new URL(window.location.toString());
  const caseId = url.searchParams.get('caseId');
  const processIdString = url.searchParams.get('processInstanceId');
  const processId = parseInt(processIdString ? processIdString : '-1');
  const serviceLine = url.searchParams.get('serviceLine') ?? '';
  const serviceLineConfig = appServiceLines.determineServiceLineConfig({
    name: serviceLine,
    caseIdentifier: `${caseId}`
  });

  const caseParams = new URLSearchParams(serviceLineConfig.caseDetailParms);

  const expandedCaseDetail: CMxAPI.Case = await api<CMxAPI.Case>({
    endpoint: `${serviceLineConfig.path}/caseinstance/${caseId}/details/${
      serviceLineConfig.caseDetailVersion
    }?${caseParams.toString()}`
  });

  const activeCaseRun = caseUtils.getCaseRun(expandedCaseDetail, processId);
  const caseDetailAndProcess = {
    caseDetail: expandedCaseDetail,
    activeProcess: activeCaseRun
  };

  return caseDetailAndProcess;
});

export { onLoad, setActiveProcess };
